export const COMPANY_BIO = {
  flag: "upside_bio_v1",
  exposureEvent: "upside_bio_experiment_entered",
  version: "bio_v1_upside_company",
  path: "/learning-center/bio/upside",
} as const;

export const COMPANY_BIO_QUERY = new URLSearchParams({
  utm_source: "twitter",
  utm_medium: "organic_social",
  utm_campaign: COMPANY_BIO.flag,
  utm_content: "upside_profile",
  placement: "bio",
}).toString();

export function getCompanyBioCampaign(search: URLSearchParams) {
  if (search.has("preview") || search.has("via")) return null;
  const expected = new URLSearchParams(COMPANY_BIO_QUERY);
  const content = search.get("utm_content");
  if (search.get("placement") === "post" && content && /^upside_post_[a-z0-9][a-z0-9_-]{0,63}$/.test(content)) {
    expected.set("placement", "post");
    expected.set("utm_content", content);
  }
  for (const key of search.keys()) {
    if (key.startsWith("utm_") && !expected.has(key)) return null;
  }
  for (const [key, value] of expected) {
    if (search.getAll(key).length !== 1 || search.get(key) !== value) return null;
  }
  return { attribution: expected, via: undefined };
}

export function skipsCompanyBioAttribution(pathname: string, search: URLSearchParams, hostname: string): boolean {
  if (pathname !== COMPANY_BIO.path) return false;
  const tagged = [...search.keys()].some((key) => key.startsWith("utm_") || key === "placement" || key === "via");
  return search.has("preview") || hostname !== "upside.tools" || (tagged && !getCompanyBioCampaign(search));
}
